"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Shield = function Shield(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "ShieldTitle ShieldDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "ShieldTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "ShieldDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(1 1)",
    d: "M12 2.82l7.5 3.36v5c0 1.52-.327 2.987-.98 4.4a10.849 10.849 0 0 1-2.66 3.56c-1.16 1.013-2.447 1.693-3.86 2.04-1.413-.347-2.7-1.027-3.86-2.04a10.849 10.849 0 0 1-2.66-3.56 10.372 10.372 0 0 1-.98-4.4v-5L12 2.82zM12 12v7.46a7.576 7.576 0 0 0 2.77-1.59 9.188 9.188 0 0 0 2.05-2.64 9.247 9.247 0 0 0 1-3.23H12zm0 0V4.66L6.18 7.24V12H12z",
    id: "refShieldGO8_W8bpqDd"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#refShieldGO8_W8bpqDd",
    fillRule: "evenodd"
  }));
};

Shield.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Shield.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Shield;
exports["default"] = _default;